import { Point, Polygon } from "geojson";
import { Identifier } from "react-admin";

import { Site } from "./sites";
import { Space } from "./spaces";
import { ColumnsOf } from "../data";
import { Maybe } from "../utility";

export interface Zone {
  id: Identifier;
  space_id: Identifier;
  site_id?: Maybe<Identifier>;
  site_name?: Maybe<string>;
  shape?: Maybe<Polygon>;
  location?: Maybe<Point>;
  site_position?: Maybe<Point>;
  point?: Maybe<Point>;
  points?: Maybe<Point[]>;
  radius?: Maybe<number>;
  name: string;
  tags: Maybe<string[]>;
  meta: Maybe<unknown>;
  spaces: Space;
  sites: Maybe<Site>;
  map_index: Maybe<number>;
}

export type ZoneInsert = Pick<
  Zone,
  "name" | "tags" | "space_id" | "site_id" | "points" | "shape" | "location" | "radius"
>;

export const ZONES_COLUMNS: ColumnsOf<Zone> = ["*", "spaces(*)", "sites(*)"] as const;
